import type {MatchFunction} from "@khanacademy/simple-markdown";

import {codeBlockFencedRule} from "./code.tsx";
import {headingRule} from "./heading.tsx";
import {graphieRule} from "./image.tsx";
import {orderedListRule, unorderedListRule} from "./list.tsx";
import {mathBlockRule} from "./math.tsx";
import {tableRule} from "./table.tsx";

/**
 * A list of match functions that are used to match non-paragraph blocks. We
 * use this list to help determine the bounds of a paragraph. Another way of
 * thinking about it is, this list contains match functions for blocks rules
 * that we'll parse out of a paragraph.
 *
 * NOTE: If you add a new block rule that shouldn't be included in a paragraph
 * block, include the matcher in this list.
 */
export const NON_PARAGRAPH_BLOCK_MATCHERS: ReadonlyArray<MatchFunction> = [
    codeBlockFencedRule.match,
    graphieRule.match,
    headingRule.match,
    mathBlockRule.match,
    orderedListRule.match,
    unorderedListRule.match,
    tableRule.match,
    // Although indented code blocks are considered a block element, the
    // current matcher causes "catastrophic backtracking" (spends too much
    // time reverting matches when a match fails) and results in browser tabs
    // crashing when it occurs. For now, we'll remove support for it until
    // a more performant matcher can be implemented.
    //
    // TODO(KORE-510): Re-enable indented code block matcher when we have a
    // more performant solution.
    // codeBlockRule.match,
    //
    // As a result, the following will be treated as a single paragraph block
    // instead of two separate blocks:
    //
    // This is considered a paragraph
    //    This is a continuation of the paragraph which normally would be a
    //    separate block
    //
] as const;
